const pricingPlans = [
  {
    name: "스타터",
    desc: "신규 설립 및 브랜드를 위한 플랜",
    original: "₩33,000",
    price: "₩19,800",
    note: "/ 월",
    button: "연간 구독",
    features: [
      "영상 내보내기 30건 / 월",
      "AI 크레딧 500개 / 월",
      "저장공간 50 GB",
    ],
    details: [
      "AI 영상자동제작",
      "영상 템플릿 900+ 개",
      "이미지 자동 사이즈 베리에이션",
      "이미지 배경 생성",
      "이미지 영상 변환",
      "이미지 자동 편집",
      "멀티채널 소셜 미디어 포스팅 및 광고 운영",
    ],
    highlight: true,
  },
  {
    name: "프로",
    desc: "중소형 브랜드 고객을 위한 플랜",
    original: "₩66,000",
    price: "₩39,600",
    note: "/ 월",
    button: "연간 구독",
    features: [
      "영상 내보내기 100건 / 월",
      "AI 크레딧 1000개 / 월",
      "저장공간 100 GB",
    ],
    details: ["폰트 및 배경음악 업로드", "콘텐츠 관리 기능"],
    highlight: false,
  },
  {
    name: "엔터프라이즈",
    desc: "대형 브랜드, 플랫폼, 에이전시 고객을 위한 플랜",
    price: "영업팀 문의",
    note: "",
    button: "컨설팅 신청",
    features: ["무제한 영상 내보내기", "무제한 AI 크레딧", "무제한 저장공간"],
    details: [
      "커스텀 영상, 이미지 템플릿",
      "API 시스템",
      "제한적 라이선스",
      "전담 고객 성공 매니저",
    ],
    highlight: false,
  },
];
// 데이터 분리: 도입 및 실행 계획
const executionPlanSteps = [
  {
    step: "1-2주",
    title: "초기 분석 및 설정",
    desc: "기업/채널/콘텐츠 현황 분석\n목표 및 KPI 설정\n채널별 콘텐츠 전략 수립",
  },
  {
    step: "1-2주",
    title: "시스템 구축",
    desc: "프롬프트 엔지니어링 설정\n채널 이동 및 API 설정\n자동화 워크플로우 구축",
  },
  {
    step: "2주",
    title: "테스트 및 최적화",
    desc: "초기 콘텐츠 생성 및 검증\n퍼포먼스 측정 및 시스템 조정\n채널별 최적화 테스트",
  },
  {
    step: "1주",
    title: "완전 자동화 전환",
    desc: "자동 스케줄링 설정\n성과 측정 시스템 연동\n운영 매뉴얼 제공",
  },
  {
    step: "지속적",
    title: "지속적 운영 지원",
    desc: "정기 성과 분석 및 보고\n분기별 전략 조정\n시스템 업데이트 및 유지보수",
  },
];
const coreFeatures = [
  "프롬프트 엔지니어링 : 채널별 특화 콘텐츠를 자동으로 생성하는 AI 명령어 설계",
  "데이터 기반 키워드 분석 : 조회수와 경쟁도를 분석해 최적의 키워드 선정",
  "AI 블로그 자동 작성 : SEO 점수 80점 이상의 콘텐츠 자동 생성",
  "숏폼, SNS 콘텐츠 자동화 : 릴스, 카드뉴스 등 모든 포맷 지원 (원하는 템플릿 제작 가능)",
  "전 채널 예약 발행 : 인스타그램, 블로그, 유튜브 등 모든 채널에 자동 업로드",
  "성과 리포트 제공 : 실시간 성과 분석 및 대시보드 (GA4, Meta 등)",
];

const imgData = [
  {
    img: "/assets/images/project/ohyoga/d31.png",
    customClass: "top-[10vw] left-[20vw]",
    size: "w-[27vw]",
  },
  {
    img: "/assets/images/project/ohyoga/b02.png",
    customClass: "top-[10vh] left-[10vw]",
    size: "w-[10vw]",
  },
  {
    img: "/assets/images/project/ohyoga/d12.png",
    customClass: "bottom-[20vh] left-[10vw]",
    size: "w-[14vw]",
  },
  {
    img: "/assets/images/project/ohyoga/e07.png",
    customClass: "bottom-[24vh] left-[32vw]",
    size: "w-[14vw]",
  },
];

const competitorComparisonTable = [
  [
    "콘텐츠 자동 생성",
    "⭐⭐⭐⭐ 텍스트, 이미지, 영상 통합",
    "주로 텍스트 중심",
    "기능 없음",
    "수동 제작",
  ],
  [
    "다채널 자동 업로드",
    "⭐⭐⭐ 블로그, SNS 동시 지원",
    "기능 없음",
    "주로 SNS 중심",
    "수동 업로드",
  ],
  [
    "키워드 분석",
    "⭐⭐⭐ 자동화 분석",
    "제한적 기능",
    "해당 없음",
    "수동 분석",
  ],
  [
    "SEO 최적화",
    "⭐⭐⭐ 채널별 최적 지원",
    "기본 제공",
    "해당 없음",
    "수동 최적화",
  ],
  [
    "통합 워크플로우",
    "⭐⭐⭐ 전 과정 자동화",
    "단일 기능",
    "일부 자동",
    "혼합 운영",
  ],
  [
    "비용 효율성",
    "월 150만원대",
    "저렴하지만 기능 제한",
    "중간 수준",
    "높은 비용",
  ],
];

const uniqueDifferentiators = [
  {
    title: "End-to-end 자동화",
    desc: "키워드 분석부터 콘텐츠 생성, 업로드까지 전 과정 완전 자동화",
  },
  {
    title: "프롬프트 엔지니어링",
    desc: "각 채널에 맞춘 프롬프트 엔지니어링 기반 고정밀 콘텐츠 자동 생성",
  },
  {
    title: "멀티모달 콘텐츠",
    desc: "텍스트, 이미지, 영상 등 모든 유형의 콘텐츠 자동 생성 및 연계",
  },
  {
    title: "비용 절감 효과",
    desc: "에이전시 대비 80% 이상, 마케팅 인력 대비 60% 이상 비용 절감 효과",
  },
];

export default function LandingALAB() {
  return (
    <div className="bg-gradient-to-b from-gray-900 via-black to-gray-900 text-white font-sans">
      {/* Hero Section */}
      <section
        className="relative h-screen bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=3550&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source
            src="https://capsule-public-objs.s3.amazonaws.com/projects/5a5addfb-245f-47cd-a74c-885747a6bef9/final_video.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-[6vw] leading-tight mb-6">
            AI 자동화, 그저 빠르기만 한가요?
          </h1>
          <span className="animate-pulse text-5xl md:text-[3.5vw] font-light tracking-tight text-white">
            Palette A.LAB은 전략까지 자동화 합니다.
          </span>
        </div>
      </section>
      <section className="px-6 md:px-12 py-60 text-center bg-gradient-to-br from-indigo-700 via-purple-800 to-purple-800 shadow-2xl">
        <h1
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="1000"
          className="text-4xl md:text-6xl font-bold mb-6 tracking-tight drop-shadow-xl"
        >
          프롬프트 엔지니어링과 데이터 분석을 기반으로
          <br />
          성과 중심 콘텐츠를 생성하고,
          <br />
          블로그부터 숏폼까지 모든 채널에 자동 게시합니다.
        </h1>
        {imgData.map((index) => (
          <div
            key={index}
            className={`absolute rounded-3xl ${index.customClass}`}
          >
            <div className={`absolute rounded-3xl ${index.size}`}>
              <img src={index.img} alt={index.img} />
            </div>
          </div>
        ))}
      </section>

      {/* Core Features */}
      <section className="px-6 md:px-12 py-24 bg-gray-950 text-white">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-indigo-400">
          핵심 기능
        </h2>
        <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
          {coreFeatures.map((feature, idx) => (
            <div
              key={idx}
              className="bg-gradient-to-br from-indigo-600 to-purple-700 p-6 rounded-2xl shadow-lg hover:scale-105 transition-transform"
            >
              <p className="text-lg font-semibold text-white drop-shadow-sm">
                {feature}
              </p>
            </div>
          ))}
        </div>
        <div className="max-w-6xl mx-auto flex justify-center">
          <img src="assets/alabImages/img_01.png" />
        </div>
      </section>

      {/* Differentiation Section */}
      <section className="px-6 md:px-12 py-28 bg-gradient-to-r from-purple-900 via-black to-indigo-900 text-center text-white">
        <h2 className="text-3xl md:text-5xl font-bold mb-10 text-fuchsia-400">
          Palette A.LAB, 무엇이 다른가요?
        </h2>
        <p className="text-xl max-w-5xl mx-auto mb-16 text-white/80">
          단순 자동화를 넘어, 전략까지 자동화하는 데이터 기반 콘텐츠 워크플로우.
          <br />
          기존 도구들이 콘텐츠 생성에만 집중하는 반면,
          <br />
          콘텐츠가 퍼질 ‘전략’과 ‘성과’를 동시에 설계.
          <br />
          텍스트, 이미지, 영상까지 모두 통합적으로 제작 가능한 국내 유일 AI
          마케팅 파트너.
        </p>

        {/* 도입 및 실행 계획 */}
        <div className="bg-white/5 rounded-2xl p-8 max-w-7xl mx-auto">
          <h3 className="text-2xl md:text-4xl font-bold mb-6 text-white">
            도입 및 실행 계획
          </h3>
          <div className="grid md:grid-cols-5 gap-6 text-sm md:text-base">
            {executionPlanSteps.map((item, i) => (
              <div
                key={i}
                className="bg-blue-900/40 p-4 rounded-xl border border-white/10"
              >
                <div className="text-sm text-blue-300 font-semibold mb-2">
                  {item.step}
                </div>
                <div className="text-lg font-bold text-white mb-1">
                  {item.title}
                </div>
                <div className="text-white/80 whitespace-pre-line">
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 경쟁 솔루션 비교 */}
        <div className="mt-20 bg-white/5 rounded-2xl p-8 max-w-7xl mx-auto">
          <h3 className="text-2xl md:text-4xl font-bold mb-6 text-white">
            경쟁 솔루션 대비 차별화 요소
          </h3>
          <div className="overflow-auto">
            <table className="w-full table-auto border-collapse text-sm md:text-base text-left text-white/90">
              <thead className="bg-blue-800 text-white">
                <tr>
                  <th className="p-3">기능/특징</th>
                  <th className="p-3">Palette A.LAB MK2</th>
                  <th className="p-3">AI 콘텐츠 생성 도구</th>
                  <th className="p-3">소셜 미디어 관리 툴</th>
                  <th className="p-3">마케팅 에이전시</th>
                </tr>
              </thead>
              <tbody className="bg-white/10">
                {competitorComparisonTable.map((row, idx) => (
                  <tr key={idx} className="border-t border-white/10">
                    {row.map((cell, cidx) => (
                      <td
                        key={cidx}
                        className="p-3 align-top whitespace-pre-line"
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* 핵심 차별화 요소 */}
          <div className="grid md:grid-cols-4 gap-6 mt-12 text-white text-left text-sm md:text-base">
            {uniqueDifferentiators.map((item, i) => (
              <div
                key={i}
                className="bg-blue-900/40 p-4 rounded-xl border border-white/10"
              >
                <div className="text-lg font-bold text-white mb-2">
                  {item.title}
                </div>
                <div className="text-white/80 whitespace-pre-line">
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Workflow Section */}
      <section className="px-6 md:px-12 py-24 bg-black text-white text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-blue-400">
          콘텐츠 자동화 흐름
        </h2>
        <div className="max-w-4xl mx-auto text-left text-white/80 space-y-4">
          <p>
            ✅ <strong>프롬프트 입력</strong> : 키워드 및 업종 등 입력으로 모든
            흐름 자동 시작
          </p>
          <p>
            ✅ <strong>키워드 분석 + 전략 설계</strong> : 검색량, 경쟁도
            기반으로 콘텐츠 방향 결정
          </p>
          <p>
            ✅ <strong>콘텐츠 생성</strong> : 텍스트 / 이미지 / 영상 동시 생성
          </p>
          <p>
            ✅ <strong>콘텐츠 최적화</strong> : SEO 점수 계산, 문장 흐름 정리 등
          </p>
          <p>
            ✅ <strong>채널별 포맷 자동 변환</strong> : 카드뉴스, 블로그, 숏폼
            등 포맷 최적화
          </p>
          <p>
            ✅ <strong>전 채널 자동 업로드</strong> : 모든 채널 자동 업로드
            (예약 스케줄링 가능)
          </p>
          <p>
            ✅ <strong>성과 분석 + 리포트</strong> : 리포트 자동 발행
          </p>
        </div>
        <div className="max-w-6xl mx-auto flex justify-center">
          <img src="assets/alabImages/img_02.png" />
        </div>
        <div className="max-w-6xl mx-auto flex justify-center">
          <img src="assets/alabImages/img_05.png" />
        </div>
      </section>

      {/* Automation Examples */}
      <section className="px-6 md:px-12 py-24 bg-gray-950 text-center text-white">
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-cyan-400">
          자동화 사례
        </h2>
        <div className="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto">
          <div className="p-8 bg-gradient-to-br from-blue-800 to-indigo-800 rounded-2xl shadow-xl">
            <h3 className="text-xl font-bold mb-3 text-white">블로그 콘텐츠</h3>
            <p className="text-white/80">
              키워드 입력 → 제목/본문/이미지 생성 → SEO 점수 확인 → 자동 게시
            </p>
            <div className="max-w-6xl mx-auto flex justify-center">
              <img src="assets/alabImages/img_03.png" />
            </div>
          </div>
          <div className="p-8 bg-gradient-to-br from-purple-800 to-fuchsia-800 rounded-2xl shadow-xl">
            <h3 className="text-xl font-bold mb-3 text-white">
              숏폼, 카드뉴스
            </h3>
            <p className="text-white/80">
              실사/애니메이션, 다양한 템플릿으로 자동 제작 및 게시
            </p>
            <div className="max-w-6xl mx-auto flex justify-center">
              <img src="assets/alabImages/img_04.png" />
            </div>
          </div>
        </div>
      </section>

      {/* Pricing & ROI */}
      <section className="px-6 md:px-12 py-24 bg-gradient-to-r from-purple-900 via-black to-indigo-900 text-white">
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center">
          가장 합리적인 요금제를 선택하세요
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {pricingPlans.map((plan, i) => (
            <div
              key={i}
              className={`rounded-2xl border shadow-lg p-8 flex flex-col justify-between ${
                plan.highlight
                  ? "bg-blue-600 text-white border-blue-500"
                  : "bg-white text-gray-900"
              }`}
            >
              <div>
                <h3 className="text-xl font-bold mb-1">{plan.name}</h3>
                <p className="text-sm mb-4 text-gray-300 md:text-gray-400">
                  {plan.desc}
                </p>
                {plan.original && (
                  <p className="text-sm line-through mb-1">{plan.original}</p>
                )}
                <p className="text-3xl font-extrabold mb-1">
                  {plan.price}{" "}
                  <span className="text-base font-medium">{plan.note}</span>
                </p>
                <button
                  className={`w-full mt-4 mb-6 py-2 px-4 rounded font-semibold text-sm ${
                    plan.highlight
                      ? "bg-white text-blue-700"
                      : "bg-black text-white"
                  }`}
                >
                  {plan.button}
                </button>
                <div className="mb-4">
                  <h4 className="text-sm font-bold mb-2">플랜 내 포함</h4>
                  <ul className="space-y-1 text-sm">
                    {plan.features.map((f, idx) => (
                      <li key={idx}>✔ {f}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  {plan.details?.length > 0 && (
                    <>
                      <h4 className="text-sm font-bold mb-2">
                        {plan.name === "프로"
                          ? "스타터 플랜의 모든 기능 +"
                          : plan.name === "엔터프라이즈"
                          ? "프로 플랜의 모든 기능 +"
                          : "주요 기능"}
                      </h4>
                      <ul className="space-y-1 text-sm">
                        {plan.details.map((f, idx) => (
                          <li key={idx}>✔ {f}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* ROI 분석 */}

        <div className="bg-white mt-8 text-gray-900 rounded-2xl p-8 shadow-xl max-w-7xl mx-auto">
          <h3 className="text-2xl font-bold mb-6">ROI 분석</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-blue-50 p-4 rounded-xl">
              <h4 className="text-lg font-semibold mb-2">
                Standard 요금제 기준
              </h4>
              <p className="text-sm leading-relaxed">
                2인 마케팅팀(월 440만원) 대체 시<br />
                초기 투자(설정비): 100만원
                <br />
                월 구독료: 150만원
                <br />
                월간 비용 절감:{" "}
                <strong className="text-green-600">290만원</strong>
                <br />
                투자 회수 기간:{" "}
                <strong className="text-blue-600">0.34개월 (약 10일)</strong>
                <br />
                연간 절감 효과: <strong>최소 3,480만원 이상</strong>
                <br />
                3년 누적 절감 효과: <strong>최소 10,440만원 이상</strong>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-xl">
              <h4 className="text-lg font-semibold mb-2">80% 이상</h4>
              <p className="text-sm">에이전시 대비 비용 절감</p>
              <h4 className="text-lg font-semibold mt-6 mb-2">60% 이상</h4>
              <p className="text-sm">인력 대비 비용 절감</p>
            </div>
            <div className="bg-blue-50 p-4 rounded-xl">
              <h4 className="text-lg font-semibold mb-2">성과 기간</h4>
              <p className="text-3xl font-bold text-blue-600">3개월 이내</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-6 md:px-12 py-24 bg-gradient-to-r from-blue-700 to-violet-700 text-white text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-6">
          지금 Palette A.LAB을 시작해보세요
        </h2>
        <p className="mb-8 text-lg">
          메일 문의 또는 카카오 채널에서 상담을 받아보세요
        </p>
        <div className="flex justify-center gap-6">
          <a
            href="mailto:contact@palette.ai"
            className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition"
          >
            메일 보내기
          </a>
          <a
            href="https://pf.kakao.com/_example"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-yellow-400 text-black px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition"
          >
            카카오 채널 문의하기
          </a>
        </div>
      </section>
    </div>
  );
}
